import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chevronup",
  "use": "icon-chevronup-usage",
  "viewBox": "0 0 64.422 24.571",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 64.422 24.571\" id=\"icon-chevronup\">\n<g id=\"icon-chevronup_chevronup\">\n\t<polyline style=\"fill:none;stroke:#808080;stroke-width:10;stroke-miterlimit:10;\" points=\"2.176,20.069 32.211,5.554 \n\t\t62.246,20.069 \t\" />\n</g>\n<g id=\"icon-chevronup_Layer_1\">\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol